import Clarity from "@microsoft/clarity";

let isInitialized = false;

/**
 * Inicialização global do Microsoft Clarity para TicketHall (Vite + React SPA)
 */
export function initClarity() {
  if (typeof window === "undefined" || isInitialized) return;

  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

  if (!projectId) {
    if (import.meta.env.DEV) {
      console.info("[Clarity] VITE_CLARITY_PROJECT_ID não configurado. Rastreamento desativado.");
    }
    return;
  }

  try {
    Clarity.init(projectId);
    isInitialized = true;
    if (import.meta.env.DEV) {
      console.info(`[Clarity] Inicializado com sucesso (projeto: ${projectId}).`);
    }
  } catch (error) {
    console.error("[Clarity] Falha ao inicializar:", error);
  }
}

/**
 * Associa o usuário logado e sua role à sessão do Clarity
 */
export function setClarityUser(user: { id?: string; email?: string | null; role?: string | null } | null) {
  if (!isInitialized || !user?.id) return;

  try {
    Clarity.identify(user.id, undefined, undefined, user.email || undefined);
    if (user.role) {
      Clarity.setTag("user_role", user.role);
    }
  } catch (error) {
    console.warn("[Clarity] Erro ao identificar usuário:", error);
  }
}

/**
 * Envia um evento customizado para o painel do Clarity
 */
export function trackClarityEvent(eventName: string) {
  if (!isInitialized) return;
  try {
    Clarity.event(eventName);
  } catch (error) {
    console.warn("[Clarity] Erro ao registrar evento:", error);
  }
}

/**
 * Define tags personalizadas para filtros no painel do Clarity
 */
export function setClarityTag(key: string, value: string | string[]) {
  if (!isInitialized) return;
  try {
    Clarity.setTag(key, value);
  } catch (error) {
    console.warn("[Clarity] Erro ao definir tag:", error);
  }
}

export { Clarity };
